import api from "../lib/api";
import {message} from "antd";
const storeUserInfo = () => dispatch => (
  api.getUserInfo().then(res => {
    if (res.success && res.status === 200) {
      dispatch({
        type: "login",
        data: res.data
      })
    } else {
      message.error(res.message);
    }
  })
);
const storeQuantileTimeList = () => dispatch => (
  api.getStatisticsType().then(res => {
    if (res.success && res.status === 200) {
      dispatch({
        type: "quantileTimeList",
        data: res.data
      })
    } else {
      message.error(res.message);
    }
  })
);
export {
  storeUserInfo,
  storeQuantileTimeList
}
